// extracted by mini-css-extract-plugin
export default {"container":"U2-z","heading":"V2-z","links":"W2-z","copy":"X2-z","subCopy":"Y2-z","linksLeft":"Z2-z","linksCenter":"_2-z","linksRight":"a3-z","link":"b3-z","onlyLink":"c3-z"};